import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import React from "react";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
import { ProtectedRoleAccountManager } from "../hooks/roles/ProtectedRoleAccountManager";

const TareaDetalleAprobarPedido = React.lazy(
  () =>
    import("../components/task/accountManager/tareaDetalleAprobarPedido/tarea-detalle-aprobar-pedido"),
);
const ErrorPage = React.lazy(() => import("../components/error-page"));

export function tareaDetalleAprobarPedido() {
  return (
    <Route
      path="/tarea-detalle-aprobar-pedido"
      element={
        <LazySuspense>
          <ProtectedRoute>
            <ProtectedRoleAccountManager>
              <LazySuspense>
                <TareaDetalleAprobarPedido />
              </LazySuspense>
            </ProtectedRoleAccountManager>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
